<template>
  <div ref="ctx" class="ctx" :style="{width: `${Math.ceil(volume*10)}px`}" />
</template>

<script>
import { ref, watchEffect } from '@vue/composition-api';
import useMicrophone from '@/compositions/useMicrophone';

export default {
  name: 'MicrophoneChart',
  setup() {
    const ctx = ref(null);
    const { volume } = useMicrophone();
    const val = ref(0);

    watchEffect(() => {
      val.value = volume.value;
    });

    return {
      ctx,
      volume,
      val,
    };
  },
};
</script>

<style scoped>
  .ctx {
    background: green;
    height: 5rem;
    display: inline-flex;
    position: absolute;
    z-index: 4;
  }
</style>
